import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import {
  Button,
  IconButton,
  Tooltip,
  DialogContent,
  Dialog,
  DialogActions,
  TextField,
} from "@mui/material";
import { toast } from "react-toastify";
import { Close } from "@mui/icons-material";
import Axios from "../axios";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";
import { CSVLink, CSVDownload } from "react-csv";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import ReactQuill from "react-quill";
import DownloadIcon from "@mui/icons-material/Download";
import "react-quill/dist/quill.snow.css";
import moment from "moment";
import { Helmet } from "react-helmet";
import { useAuth } from "../auth/authContext";
import { useLocation } from "react-router-dom";
import Loader from "./circularLoader";
const NewsRoom = () => {
  const { navData } = useAuth();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [name, setName] = useState();
  const [publishDate, setPublishDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );

  const [description, setDescription] = useState();
  const [allNews, setAllNews] = useState();
  const [userId, setUserId] = useState();
  const [opendel, setOpenDel] = useState(false);
  const [type, setType] = useState();
  const [status, setStatus] = useState(true);
  const [page, setPage] = useState(0);
  const [count, setCount] = useState();
  const [search, setSearch] = useState("");
  const [img, setImg] = useState("");
  const [loader, setLoader] = useState(false);
  const [floDeskID, setFloDeskId] = useState("");
  //data for the CSV file
  const [downloadData, setDownloadData] = useState([]);
  const [write, setWrite] = useState(false);
  //header for the CSv file

  const headers = [
    { label: "News Title", key: "title" },
    { label: "Description", key: "content" },
    { label: "Created Date", key: "createdAt" },
    { label: "Display Status", key: "userStatus" },
  ];
  useEffect(() => {
    fetchAllNews(0, "");
    handleDownloadProcess();
  }, []);

  useEffect(() => {
    const currentPath = location.pathname;
    const matchingNavItem = navData.find((item) => item.link === currentPath);
    if (matchingNavItem) {
      setWrite(matchingNavItem.write);
    } else {
      setWrite(false);
    }
  }, [location.pathname, navData]);
  const fetchAllNews = (page, search) => {
    let data = {
      page: page,
      searchChar: search,
    };
    Axios.post(process.env.REACT_APP_BACKEND + "get-all-news", data)
      .then((resp) => {
        setAllNews(resp?.data?.data?.docs);
        setCount(resp?.data?.data?.totalDocs);
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };
  const stripHtml = (html) => {
    return html.replace(/<[^>]+>/g, "");
  };
  const handleDownloadProcess = () => {
    Axios.post(process.env.REACT_APP_BACKEND + "get-news-csv-data")
      .then((resp) => {
        const processedData = resp?.data?.data.map((item) => ({
          ...item,
          content: stripHtml(item.content),
        }));
        setDownloadData(processedData);
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };
  //-------------option for the mui table----------------------------
  const options = {
    responsive: "standard",
    selectableRows: "none",
    filter: false,
    rowsPerPageOptions: [],
    viewColumns: false,
    serverSide: true,
    count: count,
    download: false,
    page,
    onTableChange: (action, tableState) => {
      if (action === "changePage") {
        fetchAllNews(tableState.page, search);
        setPage(tableState.page);
      }
    },
    onSearchChange: (searchText) => {
      fetchAllNews(page, searchText);
      setSearch(searchText);
    },
    customToolbar: () => (
      <>
        <Tooltip title="Download">
          <IconButton>
            <CSVLink
              data={downloadData}
              headers={headers}
              filename={"NewsRoom.csv"}
            >
              <DownloadIcon />
            </CSVLink>
          </IconButton>
        </Tooltip>
      </>
    ),
  };
  const removeHtmlTags = (str) => {
    const doc = new DOMParser().parseFromString(str, "text/html");
    return doc.body.textContent || "";
  };
  const columns = [
    {
      name: "Action",
      label: "Image",

      options: {
        filter: false,
        sort: false,

        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <img src={allNews[dataIndex]?.image} style={{ width: "60px" }} />
            </>
          );
        },
      },
    },
    {
      name: "title",
      label: "News Title",
      options: {
        filter: true,
        sort: false,
      },
    },

    {
      name: "content",
      label: "Description",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          const cleanAnswer = removeHtmlTags(allNews[dataIndex]?.content || ""); // Remove HTML tags
          return (
            <div className="parent-container">
              <p className="clamp-3-lines">{cleanAnswer}</p>
            </div>
          );
        },
        setCellProps: () => ({
          style: { width: "150px", whiteSpace: "normal" }, // Set width directly here
        }),
      },
    },
    {
      name: "publishedAt",
      label: "Publish Date",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <div>
              {moment(allNews[dataIndex].publishedAt).format("YYYY-MM-DD")}
            </div>
          );
        },
      },
    },
    {
      name: "display",
      label: "Display Status",
      options: {
        filter: false,
        sort: false,

        customBodyRenderLite: (dataIndex) => {
          return (
            <p
              className={`capsule ${
                allNews[dataIndex]?.display ? "published" : "unpublished"
              }`}
            >
              {allNews[dataIndex]?.display ? "Published" : "Unpublished"}
            </p>
          );
        },
      },
    },

    {
      name: "Action",
      label: "Action",

      options: {
        filter: false,
        sort: false,

        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <Tooltip title="View">
                <IconButton
                  aria-label="View News"
                  onClick={() => handleOpen(allNews[dataIndex], "view")}
                >
                  <RemoveRedEyeOutlinedIcon className="icon-size" />
                </IconButton>
              </Tooltip>
              {write ? (
                <>
                  <Tooltip title="Edit">
                    <IconButton
                      aria-label="Edit News"
                      onClick={() => handleOpen(allNews[dataIndex], "edit")}
                    >
                      <EditOutlinedIcon className="icon-size" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip
                    title={
                      allNews[dataIndex]?.display ? "Unpublish" : "Publish"
                    }
                  >
                    <IconButton
                      aria-label="sss"
                      onClick={() =>
                        handleOpen(
                          allNews[dataIndex]._id,
                          "block",
                          allNews[dataIndex]?.display
                        )
                      }
                    >
                      <BlockOutlinedIcon className="red-color fs-16 icon-size" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete">
                    <IconButton
                      aria-label="Delete News"
                      onClick={() =>
                        handleOpen(allNews[dataIndex]._id, "delete")
                      }
                    >
                      <DeleteOutlineOutlinedIcon className="red-color fs-16 icon-size" />
                    </IconButton>
                  </Tooltip>
                </>
              ) : (
                <></>
              )}
            </>
          );
        },
      },
    },
  ];

  const handleOpen = (userid, type, status) => {
    if (type === "delete") {
      setUserId(userid);
      setOpenDel(true);
    } else if (type === "block") {
      setUserId(userid);
      setOpenDel(true);
      setStatus(status);
      setType("block");
    } else if (type === "edit") {
      setName(userid?.title);
      setDescription(userid?.content);
      setUserId(userid._id);
      setFloDeskId(userid?.flodeskId);
      setType("edit");
      setOpen(true);
      setPublishDate(moment(userid?.publishedAt).format("YYYY-MM-DD"));
    } else if (type === "view") {
      setName(userid?.title);
      setPublishDate(moment(userid?.publishedAt).format("YYYY-MM-DD"));
      setDescription(userid?.content);
      setUserId(userid._id);
      setFloDeskId(userid?.flodeskId);
      setImg(userid?.image);
      setType("view");
      setOpen(true);
    } else {
      setOpen(true);
    }
  };
  const handleClose = () => {
    setOpen(false);
    setOpenDel(false);
    setType("");
    setName("");
    setFloDeskId("");
    setDescription("");
    setUserId("");
    setStatus(true);
    setPublishDate(moment(new Date()).format("YYYY-MM-DD"));
  };

  const handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    if (name === "name") {
      setName(value);
    } else if (name === "description") {
      setDescription(value);
    }
  };

  const handleSubmit = () => {
    if (name === "" || name === null || name === undefined) {
      toast.error("Title is required");
      return;
    }
    if (
      description === "" ||
      description === null ||
      description === undefined
    ) {
      toast.error("Description  is required");
      return;
    }
    setLoader(true);
    const formData = new FormData();
    let api;
    if (type === "edit") {
      api = "update-news";
      formData.append("title", name);
      formData.append("publishedAt", publishDate);
      formData.append("content", description);
      formData.append("image", img);
      formData.append("id", userId);
      formData.append("flodeskId", floDeskID);
    } else {
      formData.append("title", name);
      formData.append("publishedAt", publishDate);
      formData.append("content", description);
      formData.append("image", img);
      formData.append("flodeskId", floDeskID);
      api = "create-news";
    }
    Axios.post(process.env.REACT_APP_BACKEND + api, formData)
      .then((resp) => {
        setAllNews(resp?.data?.data?.docs);
        setCount(resp?.data?.data?.totalDocs);
        setFloDeskId("");
        setLoader(false);
        toast.success(resp && resp.data && resp.data.message);
        handleClose();
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };
  const handleDelete = () => {
    let api;
    if (type === "block") {
      api = "update-blog-status";
    } else {
      api = "delete-news";
    }
    Axios.post(process.env.REACT_APP_BACKEND + api, {
      id: userId,
    })
      .then((resp) => {
        setAllNews(resp?.data?.data?.docs);
        setCount(resp?.data?.data?.totalDocs);
        toast.success(resp && resp.data && resp.data.message);
        handleClose();
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };
  const handlePDF = (event) => {
    const selectedImage = event.target.files[0];
    setImg(selectedImage);
  };
  return (
    <>
      <Helmet>
        <title>Sevenly-News Room</title>
        <meta name="FAQ" content="FAQ for Home Page" />
      </Helmet>
      <h1 className="mb--12 sevenly-cursor"> — </h1>
      <div className="d-flex justify-content-between mb-2">
        <h2>News Room Management</h2>
        {write ? (
          <Button className="w7 pd sevenly-btn text-white" onClick={handleOpen}>
            Add
          </Button>
        ) : (
          <></>
        )}
      </div>
      <MUIDataTable
        title={"News Room List"}
        data={allNews}
        columns={columns}
        options={options}
      />

      {/* ------------------------------Create News Section ---------------------------------------- */}
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        open={open}
        maxWidth="xl"
      >
        <div className="d-flex justify-content-between align-center p-3">
          <h3>
            {" "}
            {type === "edit"
              ? "Edit News Details"
              : type === "view"
              ? "View News"
              : "Create News"}
          </h3>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </div>
        <DialogContent dividers>
          {type === "view" ? (
            <>
              <div className="viewDetials">
                <h3 className="view-style fs-20 fw-600 mb-4">{name}</h3>
                <p className="fs-12 fw-500 ms-2 mb-2">Publish Date</p>
                <div className="capsule published">{publishDate}</div>
                <div>
                  <img src={img} style={{ width: "25%" }} />
                </div>
                <div
                  className="view-style fs-14 mt-4"
                  style={{ textAlign: "justify" }}
                  dangerouslySetInnerHTML={{
                    __html: description,
                  }}
                ></div>
              </div>
            </>
          ) : (
            <>
              <p className="fs-14 fw-500 my-3">Image</p>
              <div className="col-md-6 ">
                <input
                  type="file"
                  onChange={handlePDF}
                  className="w60 gray-border mb-4"
                />
              </div>
              <p className="fs-14 fw-500 mb-3">Title</p>
              <TextField
                variant="outlined"
                required
                fullWidth
                className="my-2"
                placeholder="Enter news title"
                name="name"
                onChange={handleChange}
                value={name}
                InputProps={{
                  readOnly: type === "view",
                }}
              />
              <p className="fs-14 fw-500 mb-3">Publish Date</p>
              <TextField
                variant="outlined"
                required
                fullWidth
                className="my-2"
                type="date"
                placeholder="Enter news title"
                name="name"
                onChange={(event) => setPublishDate(event.target.value)}
                value={publishDate}
                InputProps={{
                  readOnly: type === "view",
                }}
              />
              <p className="fs-14 fw-500">FloDesk ID</p>
              <TextField
                variant="outlined"
                required
                fullWidth
                className="my-2"
                type="text"
                placeholder="FloDesk Id"
                name="name"
                onChange={(event) => setFloDeskId(event.target.value)}
                value={floDeskID}
                InputProps={{
                  readOnly: type === "view",
                }}
              />
              <div>
                <p className="fs-14 fw-500 mb-3">Description</p>
                <ReactQuill
                  theme="snow"
                  value={description}
                  className="my-2"
                  onChange={setDescription}
                  style={{ height: "300px" }}
                  readOnly={type === "view"}
                  modules={{
                    toolbar: [
                      [{ header: "1" }, { header: "2" }, { font: [] }],
                      [{ list: "ordered" }, { list: "bullet" }],
                      [{ align: [] }],
                      ["bold", "italic", "underline", "strike"],
                      [{ color: [] }, { background: [] }],
                      [{ script: "sub" }, { script: "super" }],
                      ["link", "image"],
                      ["blockquote", "code-block"],
                      ["clean"],
                    ],
                  }}
                />
              </div>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button className="cancel-button" onClick={handleClose}>
            Cancel
          </Button>
          {type !== "view" ? (
            <Button
              className="submit-button"
              variant="contained"
              onClick={handleSubmit}
            >
              <span className="me-2">
                {type === "edit" ? "Submit" : "Create"}
              </span>
              {loader && <Loader />}
            </Button>
          ) : (
            <></>
          )}
        </DialogActions>
      </Dialog>
      {/* ------------------------Delete News---------------------------------- */}
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        open={opendel}
      >
        <div className="d-flex justify-content-between align-center p-3">
          <h3>
            {type === "block" ? (status ? "Unpublish" : "Publish") : "Delete"}
          </h3>

          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </div>
        <DialogContent dividers>
          <p className="fs-14">
            {type === "block"
              ? status
                ? "Are you sure you want to unpublish the news ?"
                : "Are you sure you want to publish the news ?"
              : "Are you sure you want to delete the news ?"}
          </p>
        </DialogContent>
        <DialogActions>
          <Button className="cancel-button" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            className="submit-button"
            variant="contained"
            onClick={handleDelete}
          >
            {type === "block"
              ? status
                ? "Unpublish "
                : "Publish "
              : "Delete "}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default NewsRoom;
